import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

@NgModule()
export class IconsModule
{
    /**
     * Constructor
     */
    constructor(
        private _domSanitizer: DomSanitizer,
        private _matIconRegistry: MatIconRegistry
    )
    {
        // Register icon sets
        this._matIconRegistry.addSvgIconSet(this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-twotone.svg'));
        this._matIconRegistry.addSvgIconSetInNamespace('mat_outline', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-outline.svg'));
        this._matIconRegistry.addSvgIconSetInNamespace('mat_solid', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-solid.svg'));
        this._matIconRegistry.addSvgIconSetInNamespace('feather', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/feather.svg'));
        this._matIconRegistry.addSvgIconSetInNamespace('heroicons_outline', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-outline.svg'));
        this._matIconRegistry.addSvgIconSetInNamespace('heroicons_solid', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-solid.svg'));
         // Add Microsoft icon
         const microsoftIcon = `
         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23">
           <path fill="#f35325" d="M1 1h10v10H1z"/>
           <path fill="#81bc06" d="M12 1h10v10H12z"/>
           <path fill="#05a6f0" d="M1 12h10v10H1z"/>
           <path fill="#ffba08" d="M12 12h10v10H12z"/>
         </svg>
         `;

         this._matIconRegistry.addSvgIconLiteral(
             'microsoft-icon',
             this._domSanitizer.bypassSecurityTrustHtml(microsoftIcon)
         );



    }
}
